/* Product Fan Carousel — vanilla JS + GSAP port of the supplied React fan-card
   component. Loaded with `defer` after gsap.min.js (also `defer`), so this
   file only ever runs once GSAP is guaranteed available and the DOM parsed. */
(function () {
  var MAX_VISIBLE = 7;
  var HALF = 3;
  var FAN_POSITIONS = [
    { rot: -21, scale: 0.7756, x: -30, y: 7.3, zIndex: 1 },
    { rot: -14, scale: 0.8498, x: -22, y: 4.0, zIndex: 2 },
    { rot: -7,  scale: 0.9346, x: -11, y: 1.3, zIndex: 3 },
    { rot: 0,   scale: 1.0,    x: 0,   y: 0.0, zIndex: 10 },
    { rot: 7,   scale: 0.9346, x: 11,  y: 1.3, zIndex: 3 },
    { rot: 14,  scale: 0.8498, x: 22,  y: 4.0, zIndex: 2 },
    { rot: 21,  scale: 0.7756, x: 30,  y: 7.3, zIndex: 1 }
  ];

  function getResponsiveMultiplier(w) {
    if (w < 480) return 0.28;
    if (w < 640) return 0.38;
    if (w < 768) return 0.5;
    if (w < 1024) return 0.75;
    return 1.0;
  }
  function getHeightMultiplier(w) {
    var idealPx;
    if (w < 480) idealPx = 22 * 16;
    else if (w < 640) idealPx = 26 * 16;
    else if (w < 768) idealPx = 28 * 16;
    else if (w < 1024) idealPx = 34 * 16;
    else idealPx = 38 * 16;
    var available = window.innerHeight * 0.7;
    return available >= idealPx ? 1 : available / idealPx;
  }
  function getSlotConfig(total, slot) {
    if (total >= MAX_VISIBLE) return FAN_POSITIONS[slot];
    var center = total >> 1;
    var distance = total > 1 ? (slot - center) / center : 0;
    var absDistance = Math.abs(distance);
    return {
      rot: distance * 21,
      scale: 1.0 - 0.2244 * absDistance * absDistance,
      x: distance * 30,
      y: absDistance * absDistance * 7.3,
      zIndex: 10 - Math.abs(slot - center)
    };
  }

  function initCarousel(root) {
    if (root.dataset.pfcInit) return;
    root.dataset.pfcInit = '1';
    if (!window.gsap) return;

    var dataEl = root.querySelector('script.pfc-data');
    var cards = [];
    try { cards = JSON.parse((dataEl && dataEl.textContent) || '[]'); } catch (e) { cards = []; }
    var totalCards = cards.length;
    if (!totalCards) return;

    var needsPagination = totalCards > MAX_VISIBLE;
    var slotCount = needsPagination ? MAX_VISIBLE : totalCards;
    var centerIndex = needsPagination ? HALF : Math.floor(totalCards / 2);
    var isAnimating = false;
    var hasEntered = false;
    var direction = null;
    var prevVisible = {};

    function config(slot) { return getSlotConfig(slotCount, slot); }

    function getVisibleMap(center) {
      var map = {};
      if (!needsPagination) {
        for (var i = 0; i < totalCards; i++) map[i] = i;
        return map;
      }
      for (var slot = 0; slot < MAX_VISIBLE; slot++) {
        var idx = ((center + slot - HALF) % totalCards + totalCards) % totalCards;
        map[idx] = slot;
      }
      return map;
    }

    var layoutEl = root.querySelector('[data-pfc-layout]');
    var cardEls = Array.prototype.slice.call(root.querySelectorAll('.fan-card'));
    var controlsEl = root.querySelector('[data-pfc-controls]');
    var dotsEl = root.querySelector('[data-pfc-dots]');
    var prevBtn = root.querySelector('[data-pfc-prev]');
    var nextBtn = root.querySelector('[data-pfc-next]');

    function renderDots() {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      cards.forEach(function (_, i) {
        var dot = document.createElement('span');
        dot.className = 'pfc-dot' + (i === centerIndex ? ' is-active' : '');
        dotsEl.appendChild(dot);
      });
    }

    function layout() {
      var visibleMap = getVisibleMap(centerIndex);
      var isFirstMount = !hasEntered;
      var multiplier = getResponsiveMultiplier(window.innerWidth);
      var hMult = getHeightMultiplier(window.innerWidth);

      if (isFirstMount) isAnimating = true;

      var visibleCount = Object.keys(visibleMap).length;
      var completed = 0;
      function onCardDone() {
        completed++;
        if (completed >= visibleCount) {
          isAnimating = false;
          if (isFirstMount) hasEntered = true;
        }
      }

      cardEls.forEach(function (card, cardIndex) {
        var slot = visibleMap[cardIndex];
        var wasVisible = !!prevVisible[cardIndex];
        card.removeAttribute('data-slot');

        if (slot !== undefined) {
          card.setAttribute('data-slot', slot);
          var c = config(slot);
          var target = {
            x: (c.x * multiplier) + 'rem',
            y: (c.y * hMult) + 'rem',
            rotation: c.rot,
            scale: c.scale,
            opacity: 1,
            zIndex: c.zIndex
          };
          if (isFirstMount) {
            gsap.set(card, { x: 0, y: (12 * hMult) + 'rem', rotation: 0, scale: 0.5, opacity: 0 });
            gsap.to(card, Object.assign({}, target, { duration: 1.2, ease: 'elastic.out(1.05,.78)', delay: 0.2 + slot * 0.06, onComplete: onCardDone }));
          } else if (!wasVisible) {
            var enterX = direction === 'right' ? 40 : -40;
            gsap.set(card, { x: enterX + 'rem', y: (c.y * hMult) + 'rem', rotation: direction === 'right' ? 30 : -30, scale: 0.5, opacity: 0 });
            gsap.to(card, Object.assign({}, target, { duration: 0.6, ease: 'power2.out', onComplete: onCardDone }));
          } else {
            gsap.to(card, Object.assign({}, target, { duration: 0.5, ease: 'power2.out', onComplete: onCardDone }));
          }
        } else if (wasVisible) {
          var exitX = direction === 'right' ? -40 : 40;
          gsap.to(card, { x: exitX + 'rem', opacity: 0, scale: 0.5, rotation: direction === 'right' ? -30 : 30, duration: 0.4, ease: 'power2.in', zIndex: 0 });
        } else if (isFirstMount) {
          gsap.set(card, { opacity: 0, scale: 0.3, x: 0, y: 0, zIndex: 0 });
        }
      });

      prevVisible = visibleMap;
      renderDots();
    }

    function updateHoverLayout(hoveredSlot) {
      var mult = getResponsiveMultiplier(window.innerWidth);
      var hM = getHeightMultiplier(window.innerWidth);
      var visibleEntries = cardEls
        .map(function (el) { return { el: el, slot: el.hasAttribute('data-slot') ? parseInt(el.getAttribute('data-slot'), 10) : null }; })
        .filter(function (e) { return e.slot !== null; })
        .sort(function (a, b) { return a.slot - b.slot; });
      var centerSlot = visibleEntries.length >> 1;

      visibleEntries.forEach(function (entry) {
        var slot = entry.slot;
        var base = config(slot);
        var targetX = base.x * mult;
        var targetY = base.y * hM;
        var targetRot = base.rot;
        var targetScale = base.scale;
        var delay = 0;

        if (hoveredSlot !== null) {
          var distance = Math.abs(slot - hoveredSlot);
          delay = distance * 0.02;
          if (slot === hoveredSlot) {
            targetY -= 2.5 * hM;
            targetScale *= 1.08;
          } else {
            var normalized = centerSlot > 0 ? (slot - centerSlot) / centerSlot : 0;
            var pushStrength = 8 * (1 - Math.abs(normalized)) * (1 + 0.2 * Math.max(0, 3 - distance));
            if (slot < hoveredSlot) { targetX -= pushStrength * mult; targetRot -= 3 / (distance + 1); }
            else { targetX += pushStrength * mult; targetRot += 3 / (distance + 1); }
            if (slot === visibleEntries.length - 1 && hoveredSlot < centerSlot) targetY -= 1 * hM;
            if (slot === 0 && hoveredSlot > centerSlot) targetY -= 1 * hM;
          }
        } else {
          delay = Math.abs(slot - centerSlot) * 0.02;
        }

        gsap.to(entry.el, { x: targetX + 'rem', y: targetY + 'rem', rotation: targetRot, scale: targetScale, duration: 0.5, delay: delay, ease: 'elastic.out(1,.75)', overwrite: 'auto' });
        gsap.set(entry.el, { zIndex: base.zIndex });
      });
    }

    function cycle(dir) {
      if (isAnimating || !needsPagination) return;
      isAnimating = true;
      direction = dir;
      centerIndex = dir === 'right' ? (centerIndex + 1) % totalCards : (centerIndex - 1 + totalCards) % totalCards;
      layout();
    }

    var activeSlot = null;
    var leaveTimer = null;

    root.addEventListener('pointerover', function (e) {
      if (isAnimating) return;
      var card = e.target.closest ? e.target.closest('.fan-card') : null;
      if (!card || !card.hasAttribute('data-slot')) return;
      var slot = parseInt(card.getAttribute('data-slot'), 10);
      if (leaveTimer) { clearTimeout(leaveTimer); leaveTimer = null; }
      if (activeSlot !== slot) { activeSlot = slot; updateHoverLayout(slot); }
    });
    if (layoutEl) {
      layoutEl.addEventListener('pointerleave', function () {
        if (isAnimating) return;
        if (leaveTimer) clearTimeout(leaveTimer);
        leaveTimer = setTimeout(function () { activeSlot = null; updateHoverLayout(null); }, 50);
      });
    }
    window.addEventListener('resize', function () {
      if (!isAnimating) updateHoverLayout(activeSlot);
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { cycle('left'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { cycle('right'); });

    if (needsPagination && controlsEl) controlsEl.hidden = false;

    layout();
  }

  function boot() {
    document.querySelectorAll('[data-pfc-root]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
